import Vue from 'vue';
import Vuex from 'vuex';
import _http from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        apiUrl: 'https://cb0fwglvkj.execute-api.eu-west-1.amazonaws.com/live',
    },
    getters: {

    },
    mutations: {

    },
    actions: {
        async getOverlayData({state}, overlayId) {
            try {
                const response = await _http.get(state.apiUrl + `/overlays/${overlayId}`, {
                    headers: {
                           // remove headers
                    }
                });
                console.log('response', response);
                return response.data.data[0];
            } catch (err) {
                console.log(err);
            }
        }
    }
})